export class TeleportData {
    constructor() {
        this.teleports = [];
    }

    addLayer(teleport) {
        for (let i = 0; i < teleport.data.length; i++) {
            const tele = this.teleport;
            teleport.set(tele.id, tele);
        }

        // this.teleports.push(...teleport);
    }


    getAll(){
        return this.teleports;
    }

}
